<template>
    <div class="m-3 p-3 border bg-light text-dark" v-if="items && items.length > 0">
        <nav class="nav flex-column" id="MultiTopicNavItems">
            <a v-for="item in items " :key="item.id" class="p-1 nav-link active" :href="'#' + item.id"
                :class="{ 'ps-4': item.type == 'field' }">{{
                    item.text }}</a>

        </nav>
    </div>
</template>

<script>

export default {
    name: 'MultiTopicNav',
    props: {
        items: {
            type: Array,
            required: false
        }
    }
}
</script>

<style>

</style>